module.exports = __webpack_public_path__ + "img/lg.56837db7.png";